(() => {
  function createScrim(header) {
    let scrim = document.querySelector('.bsk-mega-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'bsk-mega-scrim';
      header.insertAdjacentElement('afterend', scrim);
    }
    return scrim;
  }

  function initializeDesktop() {
    const header = document.querySelector('.bsk-uheader[data-bsk-final-navigation]');
    const nav = header?.querySelector('.bsk-uheader__desktop-nav');
    if (!header || !nav || nav.dataset.bskFinalNavigationReady) return;
    nav.dataset.bskFinalNavigationReady = 'true';
    nav.dataset.bskFidelityReady = 'true';

    const scrim = createScrim(header);
    const items = [...nav.querySelectorAll('.bsk-uheader__nav-item')];

    const closeAll = () => {
      items.forEach((item) => {
        item.classList.remove('bsk-mega-active');
        item.querySelector(':scope > [data-bsk-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      });
      header.classList.remove('bsk-mega-open');
      scrim.classList.remove('bsk-mega-scrim--open');
    };

    items.forEach((item) => {
      const trigger = item.querySelector(':scope > [data-bsk-mega-trigger]');
      const panel = item.querySelector(':scope > .bsk-mega');
      if (!trigger || !panel) return;

      const open = () => {
        items.forEach((other) => {
          if (other === item) return;
          other.classList.remove('bsk-mega-active');
          other.querySelector(':scope > [data-bsk-mega-trigger]')?.setAttribute('aria-expanded', 'false');
        });
        item.classList.add('bsk-mega-active');
        trigger.setAttribute('aria-expanded', 'true');
        header.classList.add('bsk-mega-open');
        scrim.classList.add('bsk-mega-scrim--open');
      };

      const close = () => {
        window.setTimeout(() => {
          if (item.matches(':hover') || item.contains(document.activeElement)) return;
          item.classList.remove('bsk-mega-active');
          trigger.setAttribute('aria-expanded', 'false');
          if (nav.querySelector('.bsk-uheader__nav-item.bsk-mega-active')) return;
          header.classList.remove('bsk-mega-open');
          scrim.classList.remove('bsk-mega-scrim--open');
        }, 30);
      };

      trigger.addEventListener('click', open);
      item.addEventListener('pointerenter', open);
      item.addEventListener('pointerleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', close);
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeAll();
        trigger.focus();
      });
    });

    if (!scrim.dataset.bskFinalNavigationReady) {
      scrim.dataset.bskFinalNavigationReady = 'true';
      scrim.addEventListener('click', closeAll);
    }
  }

  function initializeMobile() {
    const details = document.querySelector('.bsk-uheader[data-bsk-final-navigation] .bsk-uheader__mobile-menu');
    const panel = details?.querySelector('.bsk-uheader__mobile-panel');
    if (!details || !panel || panel.dataset.bskFinalNavigationReady) return;
    panel.dataset.bskFinalNavigationReady = 'true';
    panel.dataset.bskFidelityReady = 'true';

    const closeDrawer = () => {
      details.open = false;
      panel.querySelectorAll('.bsk-mobile-submenu--open').forEach((submenu) => {
        submenu.classList.remove('bsk-mobile-submenu--open');
        window.setTimeout(() => { submenu.hidden = true; }, 210);
      });
    };

    panel.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-bsk-mobile-open]');
      const backButton = event.target.closest('[data-bsk-mobile-back]');
      const closeButton = event.target.closest('[data-bsk-mobile-close]');
      if (openButton) {
        const submenu = panel.querySelector(`[data-bsk-mobile-submenu="${CSS.escape(openButton.dataset.bskMobileOpen)}"]`);
        if (!submenu) return;
        submenu.hidden = false;
        requestAnimationFrame(() => submenu.classList.add('bsk-mobile-submenu--open'));
      } else if (backButton) {
        const submenu = backButton.closest('.bsk-mobile-submenu');
        submenu?.classList.remove('bsk-mobile-submenu--open');
        window.setTimeout(() => { if (submenu) submenu.hidden = true; }, 210);
      } else if (closeButton) {
        closeDrawer();
      }
    });
  }

  function initialize() {
    initializeDesktop();
    initializeMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
